import React, { useEffect, useMemo, useState } from "react";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link, useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { InitialRender } from "../../../components/common/Helper";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { GetStudentAuditTrail, GetStudentHubTabDetail } from "../../../services/StudentService";
import { checkIfImageExists, handleTableScroll } from "../../../utils/commonFunction";
import { IMAGE_URL, TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE, TABLE_TIME_FORMAT } from "../../../utils/Constants";
import { GlobalIconNames } from "../../../utils/GlobalIconNames";
import Header from "../../common/Header";
import Hover from "../../common/Hover";
import SideBar from "../../common/SideBar";
import Str from "../../common/Str";

const AuditTrail = () => {
  const history = useHistory();
  const { resource, actionId, audittrail, page } = useParams();

  const [search, setSearch] = useState("");
  const [brandData, setBrandData] = useState([]);

  const [actiontype, setActionType] = useState([]);
  const [searchActionTypeCheck, setSearchActionTypeCheck] = useState({});

  const [resourceType, setResourceType] = useState([]);
  const [searchResourceTypeCheck, setSearchResourceTypeCheck] = useState({});

  const [month, setMonth] = useState([]);
  const [searchMonthCheck, setSearchMonthCheck] = useState({});

  const [year, setYear] = useState([]);
  const [searchYearCheck, setSearchYearCheck] = useState({});
  const [isLoaded, setIsLoaded] = useState(true);
  const [tabDetail, setTabDetail] = useState("")

  useEffect(() => {
    handleTableScroll()
  }, [isLoaded])

  const fixDataFormat = (arr) => {
    let tempArr = [];
    arr.map((item) => {
      let singleItem = {
        id: item.id,
        action_id: item.action_id,
        tab_id: item.tab_id,
        action_type: item.action_type,
        resource_type: item.resource_type,
        description: JSON.parse(item.description),
      };
      tempArr.push(singleItem);
    });
    setBrandData(tempArr);
  };

  usePermissionGuardRedirect(['shview']);

  useEffect(() => {
    // setIsLoaded(false);
    const data = new FormData();
    resource != undefined && data.append("resource_type", resource ? resource : "")
    actionId != undefined && data.append("action_id", actionId ? actionId : "")
    GetStudentAuditTrail(data)
      .then((res) => {
        // fixDataFormat([])
        fixDataFormat(res.data.audit_trail);
        setIsLoaded(false);
      })
      .catch((err) => { console.log(err); setIsLoaded(false); });

    if (actionId) {
      GetStudentHubTabDetail({ tab_id: actionId })
        .then((res) => {
          setTabDetail(res.data.tabData.tab_name);
        })
        .catch((err) => console.log(err));
    }
    // setIsLoaded(false)
  }, []);

  const sortingDate = (rowA, rowB) => {
    const date1 = new Date(rowA.description.timestamp);
    const date2 = new Date(rowB.description.timestamp);

    if (date2 > date1) {
      // console.log(`${date2} is greater than ${date1}`)
      return 1;
    } else if (date2 < date1) {
      // console.log(`${date1} is greater than ${date2}`)
      return -1;
    } else {
      // console.log(`Both dates are equal`)
      return 0;
    }
  };

  const sortingName = (rowA, rowB) => {
    let key1 = "title";
    let key2 = "title";
    let type1 = "New";
    let type2 = "New";
    if (rowA.resource_type === "tabs") {
      key1 = "tab_name"
    }
    if (rowA.resource_type === "section") {
      key1 = "categoryName"
    }
    if (rowA.action_type === "Deleted") {
      type1 = "Old"
    }
    if (rowB.resource_type === "tabs") {
      key2 = "tab_name"
    }
    if (rowB.resource_type === "section") {
      key2 = "categoryName"
    }
    if (rowB.action_type === "Deleted") {
      type2 = "Old"
    }
    const name1 = rowA.description.object.definition[type1][key1] ? rowA.description.object.definition[type1][key1].toString().trim() : "";
    const name2 = rowB.description.object.definition[type2][key2] ? rowB.description.object.definition[type2][key2].toString().trim() : "";
    return name1.localeCompare(name2);
  };

  const sortingUser = (rowA, rowB) => {
    const name1 = rowA.description.User.name.toString();
    const name2 = rowB.description.User.name.toString();
    return name1.localeCompare(name2);
  };

  const difference = (obj1, obj2) => {
    let keyFound = [];
    Object.keys(obj1).forEach((key) => {
      if (obj1[key] !== obj2[key]) {
        return keyFound.push(key + ":" + obj1[key]);
      }
    });
    return keyFound;
  };

  const columns = useMemo(() => [
    {
      name: "User",
      selector: "user",
      sortable: true,
      sortFunction: sortingUser,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className="assigned-title-blk name-icon">
              {row.description.User.URL && checkIfImageExists(`${IMAGE_URL}/${row.description.User.URL.replace(
                "/home/myaie/public_html/",
                ""
              ).replace(
                "public/",
                ""
              )}`) ? (
                <img
                  src={`${IMAGE_URL}/${row.description.User.URL.replace(
                    "/home/myaie/public_html/",
                    ""
                  ).replace(
                    "public/",
                    ""
                  )}`}
                  alt="AIE"
                />
              ) : (
                InitialRender([
                  row.description.User.name.split(" ")[0],
                  row.description.User.name.split(" ")[1],
                ])
              )}

              <span
                className={`profile-box-2-status ${row.description.User.status
                  ? row.description.User.status
                  : "Offline"
                  }`}
              >
                <i className="fas fa-circle"></i>
              </span>

              <Hover
                firstName={row.description.User.name.split(" ")[0]}
                lastName={row.description.User.name.split(" ")[1]}
                photo={row.description.User.URL.replace(
                  "/home/myaie/public_html/",
                  ""
                ).replace(
                  "public/",
                  ""
                )}
                email={row.description.User.mbox}
                mobile={row.description.User?.Mobile}
                status={!row.description.User.status || row.description.User.status == "offline" ? false : true}
                right={true}
                role={"module"}
              />
            </span>
            <p>{row.description.User.name}</p>
          </div>
        </div>
      ),
    },
    {
      name: "Action Type",
      sortable: true,
      selector: "action_type",
      cell: (row) => (
        <p>
          <label htmlFor="action3">
            <span className=
              {row.action_type === "Deleted" ? "cat cat-red" : row.action_type === "Created" ? "cat cat-blue" : row.action_type === "Edited" ? "cat cat-green" : ""}>
              <i className="fas fa-circle mr-1"></i>
              {/* {row.description.verb.Action === "tab_deleted" ? "Tab Deleted" : row.description.verb.Action === "resource_deleted" ? "Resource Deleted" : row.description.verb.Action === "tab_created" ? "Tab Created" : row.description.verb.Action === "categories_created" ? "Category Created" : row.description.verb.Action === "resource_created" ? "Resource Created" : row.description.verb.Action === "categories_deleted" ? "Category Deleted" : row.description.verb.Action === "categories_edited" ? "Category Edited" : row.description.verb.Action === "tab_edited" ? "Tab Edited" : "Resource Edited"} */}
              {row.action_type}
            </span>
          </label>
        </p>
      ),
    },

    {
      name: "Resource Type",
      sortable: true,
      selector: "resource_type",
      cell: (row) => <span className={row.resource_type == "tabs" ? "as-widget as-blue-bg" : row.resource_type == "section" ? "as-widget as-green-bg" : "as-widget as-red-bg"}>{row.resource_type == "tabs" ? "Tab" : row.resource_type == "section" ? "Section" : "Resource"}</span>,
    },
    {
      name: "Resource Name",
      selector: "Name",
      sortable: true,
      sortFunction: sortingName,
      cell: (row) => {
        if (row.action_type === "Deleted") {
          const content = row.resource_type == "tabs" ? row.description.object.definition.Old.tab_name : row.resource_type == "section" ? row.description.object.definition.Old.categoryName : row.description.object.definition.Old.title;
          return (
            <p title={content}>
              {content}
            </p>
          );
        } else {
          const content = row.resource_type == "tabs" ? row.description.object.definition.New.tab_name : row.resource_type == "section" ? row.description.object.definition.New.categoryName : row.description.object.definition.New.title;
          return (
            <Link className="as-text-blue curser" to={`/support/student-hub-library/student-hub/open/${row.tab_id}`}>
              <div className="assigned-title-block-new">
                <div className="assigned-title-itm textLimit100">
                  <p title={content}>
                    {content}
                  </p>
                </div>
              </div>
            </Link>
          );
        }
      },
    },

    {
      name: "Old Value",
      // sortable: true,
      cell: (row) => {
        const entries = Object.entries(row.description.object.definition?.Old);
        if (row.action_type === "Created") {
          return "N/A";
        } else if (row.action_type === "Edited") {
          const diff = difference(row.description.object.definition?.Old, row.description.object.definition?.New);
          return diff.length !== 0 ? (
            <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>

              {diff.sort().map((entry, index) => (
                index < 2 && <p key={index}>{entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry.toString()}</p>
              ))}

              {diff.length > 2 ? "..." : null}
            </div>
          ) : (
            "NA"
          );
        } else {
          const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
          return entries.length < 2
            ?
            <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>
              {diff.sort().map((entry, index) => {
                return (index < 2 && <p key={index}>
                  {entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry.toString()}
                </p>)
              })}
              {diff.length > 2 ? "..." : null}
            </div>
            :
            <div className="tooltip-custom" title={`${entries.map(entry => entry.toString())}`.split(',').join("\n")}>
              {entries.slice(0, 2).map((entry, index) => {
                return (index < 2 && <p key={index}>
                  {entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}
                </p>)
              })}
              {entries.length > 2 ? "..." : null}
            </div>
        }
      },
    },
    {
      name: "New Value",
      // sortable: true,
      cell: (row) => {
        const entries = Object.entries(row.description.object.definition?.New);
        if (row.description.verb.Action === "Edited") {
          const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
          return diff.length !== 0 ? (
            <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>
              {diff.length < 2
                ? diff.sort().map((entry, index) => {
                  return index < 2 && <p key={index}>{entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}</p>;
                })
                : diff
                  .slice(0, 2)
                  .sort()
                  .map((entry, index) => {
                    return index < 2 && <p key={index}>{entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}</p>;
                  })}
            </div>
          ) : (
            "N/A"
          );
        } else {
          const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
          return entries.length < 2
            ?
            <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>
              {diff.sort().map((entry, index) => {
                return (index < 2 && <p key={index}>
                  {entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}
                </p>)
              })}
              {diff.length > 2 ? "..." : null}
            </div>
            :
            <div className="tooltip-custom" title={`${entries.map(entry => entry[0] + ":" + (entry[1] ? entry[1] : "NA"))}`.split(',').join("\n")}>
              {entries.slice(0, 2).map((entry, index) => {
                return (index < 2) && (<p key={index} >
                  {entry[0]}:{entry[1] ? ((entry[1].toString()).length > 30 ? (entry[1].toString()).slice(0, 30) + "..." : (entry[1].toString())) : "N/A"}
                </p>)
              })}
              {entries.length > 2 ? "..." : null}
            </div>

        }
      },
    },

    {
      name: "Date",
      sortable: true,
      selector: "Date",
      sortFunction: sortingDate,
      cell: (row) => {
        let today = new Date().toLocaleDateString();
        return row.description.timestamp ? (
          <>
            <p>{moment(row.description.timestamp).format(TABLE_DATE_FORMAT + ",")}</p>
            <p>{moment(row.description.timestamp).format(TABLE_TIME_FORMAT)}</p>
          </>
        ) : (
          "NA"
        );
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              onClick={() => {
                Swal.fire({ html: `<div className="audit-trial-json"><pre>${JSON.stringify(row.description, undefined, 1)}</pre></div>` });
              }}
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleActionTypeFilter = (e) => {
    const value = e.target.value;
    let arr = actiontype;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setActionType(arr);
    let id = e.target.id;
    setSearchActionTypeCheck({
      ...searchActionTypeCheck,
      [id]: !searchActionTypeCheck[id],
    });
  };

  const handleResourceTypeFilter = (e) => {
    const value = e.target.value;
    let arr = resourceType;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setResourceType(arr);
    let id = e.target.id;
    setSearchResourceTypeCheck({
      ...searchResourceTypeCheck,
      [id]: !searchResourceTypeCheck[id],
    });
  };

  const handleMonthFilter = (e) => {
    const value = e.target.value;
    let arr = month;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setMonth(arr);
    let id = e.target.id;
    setSearchMonthCheck({ ...searchMonthCheck, [id]: !searchMonthCheck[id] });
  };

  const handleYearFilter = (e) => {
    const value = e.target.value;
    let arr = year;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setYear(arr);
    let id = e.target.id;
    setSearchYearCheck({ ...searchYearCheck, [id]: !searchYearCheck[id] });
  };

  const renderMonthUI = () => {
    let arr = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return arr.map((i, index) => {
      return (
        <li key={index}>
          <input
            type="checkbox"
            id={index}
            value={index}
            onClick={handleMonthFilter}
            checked={searchMonthCheck[index]}
          />
          <label htmlFor={index}>
            <span>{i}</span>
          </label>
        </li>
      );
    });
  };

  const renderYearUI = () => {
    let arr = ["2022", "2021", "2020"];
    return arr.map((i, index) => {
      return (
        <li key={index}>
          <input
            type="checkbox"
            id={i}
            value={i}
            onClick={handleYearFilter}
            checked={searchYearCheck[i]}
          />
          <label htmlFor={i}>
            <span>{i}</span>
          </label>
        </li>
      );
    });
  };

  const dataToRender = () => {
    let updatedData = [];
    let allData = brandData;
    if (search.length) {
      // let tempId = allData.filter((item) => {
      //   let includes = item.id.toString().includes(search.toLowerCase());
      //   if (includes) {
      //     return includes;
      //   } else return null;
      // });

      let tempUser = allData.filter((item) => {
        let includes = item.description.User.name.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let tempName = allData.filter((item) => {

        let includes = item.resource_type == "tabs" ? item.description.object.definition.New.tab_name
          ? item.description.object.definition.New.tab_name.toString().toLowerCase().includes(search.toLowerCase())
          : item.description.object.definition.Old.tab_name.toString().toLowerCase().includes(search.toLowerCase()) :
          item.resource_type == "section" ? item.description.object.definition.New.categoryName
            ? item.description.object.definition.New.categoryName.toString().toLowerCase().includes(search.toLowerCase())
            : item.description.object.definition.Old.categoryName.toString().toLowerCase().includes(search.toLowerCase()) :
            item.description.object.definition.New.title
              ? item.description.object.definition.New.title.toLowerCase().toString().includes(search.toLowerCase())
              : item.description.object.definition.Old.title ? item.description.object.definition.Old.title.toString().toLowerCase().includes(search.toLowerCase()) : ""

        if (includes) {
          return includes;
        } else return null;
      });
      let data = [...tempUser, ...tempName];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (actiontype.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = actiontype.find((post, index) => {
          if (post.toString() === item.action_type.toString())
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (resourceType.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = resourceType.find((post, index) => {
          if (post.toString() === item.resource_type.toString())
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (month.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = month.find((post, index) => {
          let monthNumber = new Date(item.description.timestamp).getMonth();
          if (post.toString() === monthNumber.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (year.length) {
      let tempYear = updatedData;
      let tempResult = tempYear.filter((item) => {
        const startsWith = year.find((post, index) => {
          let yearNumber = new Date(item.description.timestamp).getFullYear();
          if (post.toString() === yearNumber.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    return updatedData;
  };

  const resetFilter = () => {
    setSearch("");
    setActionType([]);
    setSearchActionTypeCheck({});
    setMonth([]);
    setSearchMonthCheck({});
    setYear([]);
    setSearchYearCheck({});
    setResourceType([]);
    setSearchResourceTypeCheck({});
  };

  const oldValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.Old);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(
        row.description.object.definition?.Old,
        row.description.object.definition?.New
      );
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    }
    // else if (row.description.verb.Action === "Profile Picture Edited") {
    //   return  row.description.object.definition?.Old?.picture_me;
    // }
    else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`;
    }
  };

  const NewValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.New);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(
        row.description.object.definition?.New,
        row.description.object.definition?.Old
      );
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    } else if (row.description.verb.Action === "Profile Picture Edited") {
      return row.description.object.definition?.New?.picture_me.toString()
        .length > 30
        ? "picture_me:" + row.description.object.definition?.New?.picture_me
        : row.description.object.definition?.New?.picture_me;
    } else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`;
    }
  };

  const modifiedData = () => {
    let data = dataToRender();

    data = data?.map((row) => ({
      ...row,
      // ID: row?.id,
      User: row.description.User.name,
      "Resource Name": row.resource_type == "tabs" ? row.description.object.definition.New.tab_name
        ? row.description.object.definition.New.tab_name : row.description.object.definition.Old.tab_name
        : row.resource_type == "section" ? row.description.object.definition.New.categoryName
          ? row.description.object.definition.New.categoryName : row.description.object.definition.Old.categoryName
          : row.description.object.definition.New.title ? row.description.object.definition.New.title
            : row.description.object.definition.Old.title ? row.description.object.definition.Old.title : "NA",
      "Resource Type": row.resource_type,
      "Action Type": row.description.verb.Action,
      // "Old Value": Object.keys(row.description.object.definition.Old).length !== 0 ? `${Object.entries(row.description.object.definition.Old).map((entry) => entry[0] + ":" + entry[1])}` : "NA",
      "Old Value": Object.keys(row.description.object.definition.Old).length !== 0 ? oldValue(row) : "NA",
      // "New Value": Object.keys(row.description.object.definition.New).length !== 0 ? `${Object.entries(row.description.object.definition.New).map((entry) => entry[0] + ":" + entry[1])}` : "NA",
      "New Value": Object.keys(row.description.object.definition.New).length !== 0 ? NewValue(row) : "NA",
      Date: new Date(row.description.timestamp).toLocaleDateString(),
    }));

    return data;
  };

  const exportData = (fileType, fileName) => {
    let data = modifiedData();

    const header = [
      "User",
      "Resource Type",
      "Action Type",
      "Resource Name",
      "Old Value",
      "New Value",
      "Date",
    ];

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      // console.log(csvString);
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.map((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data.map((row) => {
        return [
          row["User"],
          row["Resource Type"],
          row["Action Type"],
          row["Resource Name"].trim(),
          row["Old Value"],
          row["New Value"],
          row["Date"],
        ];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        columnStyles: {
          0: {
            columnWidth: 20,
          },
          1: {
            columnWidth: 24,
          },
          2: {
            columnWidth: 24,
          },
          3: {
            columnWidth: 24,
          },
          4: {
            columnWidth: 40,
          },
          5: {
            columnWidth: 40,
          },
          6: {
            columnWidth: 20,
          },
        },
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  return (
    <>
      <Header></Header>
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar></SideBar>
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            {/* <Tabs /> */}
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2"><div className="d-flex align-items-center ">
                  <div className="name-w-head d-flex align-items-center ">
                    {actionId ? <h4 className="text-left-align landing-heading heading_color_dynamic">Tab: <span>{tabDetail}</span> </h4> : 
                    <h4 className="text-left-align landing-heading heading_color_dynamic">Student <span>Hub</span> </h4>}
                  </div>
                  <div className="text-md-right action2-blk">
                    <div className="ticket-view-btn d-flex align-items-center">
                      <div className="add-new-ticket-bx">
                        <button onClick={() => history.goBack()} title="Back" className="btn btn-white-bordered">
                          <i className="fal fa-angle-left"></i>Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                <div className="tabs-wrap">
                  {!actionId ?
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() => history.push("/support/student-hub-library/student-hub/list")}
                      >
                        <a
                          className="nav-link"
                          id="pills-tab1"
                          data-toggle="pill"
                          href="#pills-tab11"
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                        >
                          <i className="fal fa-users-cog"></i>
                          Tab List
                        </a>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push("/support/student-hub-library/student-hub/student-audit-trail")
                        }
                      >
                        <a
                          className="nav-link active "
                          id="pills-tab2"
                          data-toggle="pill"
                          href="#pills-tab12"
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                        >
                          {GlobalIconNames('audittrail').html}
                        </a>
                      </li>
                    </ul>
                    : <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() => history.push(`/support/student-hub-library/student-hub/open/${actionId}`)}
                      >
                        <a
                          className="nav-link"
                          id="pills-tab1"
                          data-toggle="pill"
                          href="#pills-tab11"
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                        >
                          <i className="fal fa-info-circle"></i>
                          Details
                        </a>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() => history.push({ pathname: `/support/student-hub-library/student-hub/open/${actionId}/student-audit-trail` })}
                      >
                        <a
                          className="nav-link active "
                          id="pills-tab2"
                          data-toggle="pill"
                          href="#pills-tab12"
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                        >
                          {GlobalIconNames('audittrail').html}
                        </a>
                      </li>
                    </ul>}

                  {!actionId ?
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() => history.push("student-audit-trail")}
                      >
                        <a
                          className={`nav-link ${page.includes("student-audit-trail") ? "active" : ""}`}
                          id="pills-tab1"
                          data-toggle="pill"
                          href="#pills-tab13"
                          role="tab"
                          aria-controls="pills-tab13"
                          aria-selected="true"
                        >
                          <i className="fal fa-history"></i>
                          Student Audit Trail
                        </a>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push("/support/student-hub-library/student-hub/employee-audit-trail")
                        }
                      >
                        <a
                          className={`nav-link ${page.includes("employee-audit-trail") ? "active" : ""}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          href="#pills-tab14"
                          role="tab"
                          aria-controls="pills-tab14"
                          aria-selected="true"
                        >
                          {GlobalIconNames('onlyiconaudittrail')}Employee Audit Trail
                        </a>
                      </li>
                    </ul>
                    : <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() => history.push({ pathname: `/support/student-hub-library/student-hub/open/${actionId}/student-audit-trail` })}
                      >
                        <a
                          className={`nav-link ${audittrail.includes("student-audit-trail") ? "active" : ""}`}
                          id="pills-tab1"
                          data-toggle="pill"
                          href="#pills-tab13"
                          role="tab"
                          aria-controls="pills-tab13"
                          aria-selected="true"
                        >
                          {GlobalIconNames('onlyiconaudittrail')}
                          Student Audit Trail
                        </a>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() => history.push({ pathname: `/support/student-hub-library/student-hub/open/${actionId}/employee-audit-trail` })}
                      >
                        <a
                          className={`nav-link ${audittrail.includes("employee-audit-trail") ? "active" : ""}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          href="#pills-tab14"
                          role="tab"
                          aria-controls="pills-tab14"
                          aria-selected="true"
                        >
                          {GlobalIconNames('onlyiconaudittrail')}Employee Audit Trail
                        </a>
                      </li>
                    </ul>}
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      <div className="my-tickets-info-list Tickets-main-wrap">
                        <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
                          <div className="search-filter-div">
                            <div className="search-filter-div-left">
                              <div className="system-administration-table table-responsive">
                                <div className="table-responsive-div">
                                  <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                      <div id="assessment-table-main_filter" className="dataTables_filter">
                                        <label>
                                          <input
                                            type="search"
                                            className=""
                                            placeholder="Search"
                                            aria-controls="assessment-table-main"
                                            onChange={handleSearchFilter}
                                            value={search}
                                          />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                          <button className="filter-buttons">
                                            <i className="fal fa-filter"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-button-group">
                                  <div className="filter-scroll">
                                    <div className={`filter-scroll-inner  filter-custom-new`}>
                                      <div className="assessment-table-filter">
                                        <div className="btn-type-filter dropdown-comman">
                                          <div className="dropdown multiselect">
                                            <button
                                              className={`btn btn-default dropdown-toggle ${actiontype.length ? "btn-selected" : ""
                                                }`}
                                              type="button"
                                              id="dropdownMenu1"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="Action Type"
                                            >
                                              <span>
                                                Action Type{" "}
                                                <i className="fal fa-angle-down"></i>
                                              </span>
                                            </button>
                                            <form className="dropdown-menu remove-list-style">
                                              <ul aria-labelledby="dropdownMenu1">
                                                <li className="cat cat-skyblue">
                                                  <input
                                                    type="checkbox"
                                                    id="action1"
                                                    value="Created"
                                                    onClick={handleActionTypeFilter}
                                                    checked={
                                                      searchActionTypeCheck.action1
                                                    }
                                                  />
                                                  <label htmlFor="action1">
                                                    <span className="cat cat-blue">
                                                      <i className="fas fa-circle mr-1"></i>{" "}
                                                      Created
                                                    </span>
                                                  </label>
                                                </li>
                                                <li className="cat cat-greenhex">
                                                  <input
                                                    type="checkbox"
                                                    id="action2"
                                                    value="Edited"
                                                    onClick={handleActionTypeFilter}
                                                    checked={
                                                      searchActionTypeCheck.action2
                                                    }
                                                  />
                                                  <label htmlFor="action2">
                                                    <span className="cat cat-greenhex">
                                                      <i className="fas fa-circle mr-1"></i>{" "}
                                                      Edited
                                                    </span>
                                                  </label>
                                                </li>
                                                <li className="cat cat-red">
                                                  <input
                                                    type="checkbox"
                                                    id="action3"
                                                    value="Deleted"
                                                    onClick={handleActionTypeFilter}
                                                    checked={
                                                      searchActionTypeCheck.action3
                                                    }
                                                  />
                                                  <label htmlFor="action3">
                                                    <span className="cat cat-red">
                                                      <i className="fas fa-circle mr-1"></i>{" "}
                                                      Deleted
                                                    </span>
                                                  </label>
                                                </li>
                                              </ul>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                      {!resource && <div className="assessment-table-filter">
                                        <div className="btn-type-filter dropdown-comman">
                                          <div className="dropdown multiselect">
                                            <button
                                              className={`btn btn-default dropdown-toggle ${resourceType.length ? "btn-selected" : ""
                                                }`}
                                              type="button"
                                              id="dropdownMenu1"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="Resource Type"
                                            >
                                              <span>
                                                Resource Type{" "}
                                                <i className="fal fa-angle-down"></i>
                                              </span>
                                            </button>
                                            <form className="dropdown-menu remove-list-style">
                                              <ul aria-labelledby="dropdownMenu1">
                                                <li className="">
                                                  <input
                                                    type="checkbox"
                                                    id="resource1"
                                                    value="tabs"
                                                    onClick={handleResourceTypeFilter}
                                                    checked={
                                                      searchResourceTypeCheck.resource1
                                                    }
                                                  />
                                                  <label htmlFor="resource1">
                                                    <span className="as-widget as-blue-bg">
                                                      Tab
                                                    </span>
                                                  </label>
                                                </li>
                                                <li className="">
                                                  <input
                                                    type="checkbox"
                                                    id="resource2"
                                                    value="section"
                                                    onClick={handleResourceTypeFilter}
                                                    checked={
                                                      searchResourceTypeCheck.resource2
                                                    }
                                                  />
                                                  <label htmlFor="resource2">
                                                    <span className="as-widget as-green-bg">
                                                      Section
                                                    </span>
                                                  </label>
                                                </li>
                                                <li className="">
                                                  <input
                                                    type="checkbox"
                                                    id="resource3"
                                                    value="resources"
                                                    onClick={handleResourceTypeFilter}
                                                    checked={
                                                      searchResourceTypeCheck.resource3
                                                    }
                                                  />
                                                  <label htmlFor="resource3">
                                                    <span className="as-widget as-red-bg">
                                                      Resource
                                                    </span>
                                                  </label>
                                                </li>
                                              </ul>
                                            </form>
                                          </div>
                                        </div>
                                      </div>}
                                      <div className="assessment-table-filter">
                                        <div className="btn-type-filter dropdown-comman">
                                          <div className="dropdown multiselect">
                                            <button
                                              className={`btn btn-default dropdown-toggle ${month.length ? "btn-selected" : ""
                                                }`}
                                              type="button"
                                              id="dropdownMenu1"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="Month"
                                            >
                                              <span>
                                                Month{" "}
                                                <i className="fal fa-angle-down"></i>
                                              </span>
                                            </button>
                                            <form className="dropdown-menu remove-list-style">
                                              <ul aria-labelledby="dropdownMenu1">
                                                {renderMonthUI()}
                                              </ul>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="assessment-table-filter">
                                        <div className="btn-type-filter dropdown-comman">
                                          <div className="dropdown multiselect">
                                            <button
                                              className={`btn btn-default dropdown-toggle ${year.length ? "btn-selected" : ""
                                                }`}
                                              type="button"
                                              id="dropdownMenu1"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                              title="Year"
                                            >
                                              <span>
                                                Year{" "}
                                                <i className="fal fa-angle-down"></i>
                                              </span>
                                            </button>
                                            <form className="dropdown-menu remove-list-style">
                                              <ul aria-labelledby="dropdownMenu1">
                                                {renderYearUI()}
                                              </ul>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                      <button
                                        className="btn btn-primary"
                                        onClick={resetFilter}
                                        title="Reset"
                                      >
                                        <i className="fal fa-redo"></i>Reset
                                      </button>
                                    </div>
                                    <div className="files-export-group">
                                      <button
                                        type="button"
                                        className="btn btn-files"
                                        onClick={() => {
                                          exportData("xlsx", "Student Hub Audit Trail");
                                        }}
                                        title="Export spreadsheet"
                                      >
                                        <i className="fal fa-file-excel icon"></i>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-files"
                                        onClick={() => {
                                          exportData("csv", "Student Hub Audit Trail");
                                        }}
                                        title="Export CSV"
                                      >
                                        <i className="fal fa-file-csv icon"></i>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-files"
                                        onClick={() => {
                                          exportData("pdf", "Student Hub Audit Trail");
                                        }}
                                        title="Export PDF"
                                      >
                                        <i className="fal fa-file-pdf icon"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="search-filter-div-right">
                              <div className=" filter-search-bar-blk">
                              </div>
                            </div>
                          </div>
                          {isLoaded && <SkeletonTicketList />}
                          <DataTable data={dataToRender()} defaultSortField="Date" defaultSortAsc={true} columns={columns} pagination={true} noDataComponent={Str.noRecord} paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default AuditTrail;
